import { PROFILE_TYPES } from '@/utils/enums';
import Dashboard from '@/layouts/Dashboard';
import affiliateRoutes from './affiliate';
import specialistRoutes from './specialist';
import developerRoutes from './developer';

const router = [
    {
        path: '/',
        component: Dashboard,
        meta: { auth: true },
        children: [
            {
                path: '',
                component: () => import('@/views/home'),
                name: 'home',
                meta: { auth: true },
            },
            {
                path: '/bank-account',
                name: 'bank-account',
                component: () => import('@/views/bank'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.AFFILIATE, PROFILE_TYPES.SPECIALIST] },
            },
            {
                path: '/commission',
                name: 'commission',
                component: () => import('@/views/commission'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.AFFILIATE, PROFILE_TYPES.SPECIALIST] },
            },
            {
                path: '/dashboard',
                name: 'dash',
                component: () => import('@/views/dash'),
                meta: {
                    auth: true,
                    hasQueryParamPage: true,
                },
            },
            {
                path: '/profile',
                name: 'profile',
                component: () => import('@/views/profile'),
                meta: { auth: true },
            },
            ...affiliateRoutes,
            ...specialistRoutes,
            ...developerRoutes,
        ],
    },
];

export default router;
